module.exports = __webpack_public_path__ + "img/key.65a2d372.svg";